module.exports = __webpack_public_path__ + "img/xz_ico.6aeecacd.png";